import { render, staticRenderFns } from "./Otherprocurement.vue?vue&type=template&id=7edec66c&scoped=true"
import script from "./Otherprocurement.vue?vue&type=script&lang=js"
export * from "./Otherprocurement.vue?vue&type=script&lang=js"
import style0 from "./Otherprocurement.vue?vue&type=style&index=0&id=7edec66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edec66c",
  null
  
)

export default component.exports